import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SidenavService } from '@services/sidenav.service';
import { SidebarItem } from '@shared/sidebaritem';
import { sidebarItems } from './menu';

@Component({
	selector: 'app-masterdata',
	templateUrl: './masterdata.component.html',
	styleUrls: ['./masterdata.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class MasterdataComponent implements OnInit {
	public sidebarItems: SidebarItem[] = sidebarItems;

	constructor(private sidenavService: SidenavService) {}

	ngOnInit(): void {
		this.sidenavService.setMenuData(this.sidebarItems);
		void this.sidenavService.closeRightPanel();
	}
}
